export default "__VITE_ASSET__DKpxJJ1u__"